export const common = {
  nav: {
    home: 'Início',
    services: 'Serviços',
    about: 'Sobre',
    history: 'História',
    contact: 'Contato'
  },
  hero: {
    title: 'Certificação e Assessoria Técnica com',
    titleHighlight: 'Excelência',
    description: 'Apoio técnico completo para certificar seus produtos com agilidade e confiança. Especialistas em INMETRO, ANATEL, ANVISA e registro de fabricantes.',
    ctaPrimary: 'Solicitar Consultoria',
    ctaSecondary: 'Nossos Serviços',
    yearsExperience: 'Anos de Experiência',
    compliance: 'Conformidade'
  },
  services: {
    title: 'Nossos Serviços',
    subtitle: 'Soluções completas em certificação e assessoria técnica para garantir a conformidade dos seus produtos',
    inmetro: {
      title: 'Certificação INMETRO',
      description: 'Certificação completa de produtos junto ao INMETRO, incluindo eficiência energética, segurança e qualidade. Acompanhamento de todo o processo de avaliação da conformidade com expertise técnica especializada.'
    },
    anatel: {
      title: 'Homologação ANATEL',
      description: 'Homologação de equipamentos de telecomunicações perante a ANATEL. Assessoria completa para produtos que utilizam radiofrequência, garantindo conformidade com as normas técnicas brasileiras.'
    },
    anvisa: {
      title: 'Registro ANVISA',
      description: 'Registro de produtos junto à ANVISA, incluindo equipamentos médicos, cosméticos e produtos para saúde. Suporte técnico especializado em regulamentação sanitária e documentação técnica.'
    },
    suppliers: {
      title: 'Registro de Fornecedores',
      description: 'Assessoria completa para registro de fabricantes nos órgãos reguladores. Preparação de documentação técnica, adequação de processos produtivos e acompanhamento de auditorias.'
    },
    testing: {
      title: 'Acompanhamento de Testes',
      description: 'Acompanhamento técnico de ensaios e testes em laboratórios acreditados. Análise de relatórios, identificação de não conformidades e orientação para adequações necessárias.'
    },
    consulting: {
      title: 'Consultoria Especializada',
      description: 'Consultoria técnica em avaliação da conformidade, eficiência energética e normas técnicas. Suporte estratégico para adequação de produtos às exigências regulatórias brasileiras.'
    }
  },
  about: {
    title: 'Sobre a APL Consultoria',
    description1: 'A APL Consultoria e Assessoria Técnica é voltada para o apoio técnico completo para clientes que visam certificar seus produtos com agilidade e confiança.',
    description2: 'Com mais de 19 anos de experiência na área de certificações técnicas e regulatórias, oferecemos suporte especializado em INMETRO, ANATEL, ANVISA e registro de fabricantes.',
    description3: 'Nossa expertise abrange desde o acompanhamento de testes e ensaios até a consultoria especializada em avaliação da conformidade, garantindo que seus produtos atendam a todos os requisitos regulatórios brasileiros.',
    yearsExperience: 'Anos de Experiência',
    complianceGuaranteed: 'Conformidade Garantida',
    badge: 'Especialista em Certificação e Avaliação da Conformidade'
  },
  experience: {
    title: 'Histórico de Atuação',
    subtitle: 'Desde 2005, dedicado à área de certificações técnicas e regulatórias',
    timeline: [
      {
        period: '2005 - 2016',
        title: 'Responsável Técnico no INMETRO',
        description: 'Responsável técnico em programas de avaliação da conformidade na Diretoria de Avaliação de Conformidade – DConf – no INMETRO.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordenador de Comissões Técnicas',
        description: 'Coordenador da Comissão Técnica em Eficiência Energética de Motores Elétricos, Bombas Centrífugas, Iluminação, Condicionadores de Ar, Micro-ondas, Televisores, Ventiladores, Transformadores de Distribuição e Refrigeradores.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordenador Técnico em Eletrodomésticos',
        description: 'Coordenador da Comissão Técnica em Eletrodomésticos e Similares, garantindo padrões de qualidade e segurança.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordenador Técnico do CGIEE - MME',
        description: 'Coordenador Técnico do Comitê Técnico de Eletrodomésticos do Comitê Gestor de Indicadores e Níveis de Eficiência Energética – CGIEE – Ministério de Minas e Energia – MME.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordenador Técnico Brasileiro na COPANT',
        description: 'Coordenador Técnico Brasileiro na Comissão Pan-americana de Normas Técnicas – COPANT, representando o Brasil em normatizações internacionais.'
      },
      {
        period: '2018 - 2019',
        title: 'Coordenador Executivo e Diretor Substituto',
        description: 'Coordenador da Coordenação Executiva e de Gestão da DConf – CEXEC – e Diretor Substituto da DConf no INMETRO.'
      },
      {
        period: '2009 - Presente',
        title: 'Especialista e Auditor-Líder CGCRE',
        description: 'Especialista externo da Coordenação Geral de Acreditação – CGCRE – no INMETRO e Auditor-Líder em auditorias na área elétrica.'
      }
    ]
  },
  contact: {
    title: 'Entre em Contato',
    subtitle: 'Solicite uma consultoria especializada e descubra como podemos ajudar na certificação dos seus produtos',
    phone: 'Telefone',
    email: 'E-mail',
    hours: 'Horário de Atendimento',
    hoursValue: 'Segunda a Sexta: 9h às 18h',
    whyChoose: 'Por que escolher a APL?',
    reasons: [
      'Mais de 19 anos de experiência em certificações',
      'Ex-coordenador técnico do INMETRO',
      'Auditor-líder em auditorias na área elétrica',
      'Assessoria completa e personalizada'
    ],
    formTitle: 'Solicite uma Consultoria',
    formName: 'Nome Completo',
    formEmail: 'E-mail',
    formPhone: 'Telefone',
    formCompany: 'Empresa',
    formService: 'Serviço de Interesse',
    formMessage: 'Mensagem',
    formNamePlaceholder: 'Seu nome completo',
    formEmailPlaceholder: 'seu@email.com',
    formPhonePlaceholder: '(00) 00000-0000',
    formCompanyPlaceholder: 'Nome da sua empresa',
    formServicePlaceholder: 'Selecione um serviço',
    formMessagePlaceholder: 'Descreva suas necessidades de certificação... (máximo 500 caracteres)',
    formMaxChars: 'Máximo de 500 caracteres',
    formSubmit: 'Enviar Solicitação',
    formSubmitting: 'Enviando...',
    formSuccess: 'Mensagem enviada com sucesso! Entraremos em contato em breve.',
    formError: 'Erro ao enviar mensagem. Por favor, tente novamente.'
  },
  footer: {
    description: 'Certificação e assessoria técnica com excelência desde 2005.',
    servicesTitle: 'Serviços',
    contactTitle: 'Contato',
    hoursTitle: 'Horário',
    hoursValue: 'Segunda a Sexta\n9h às 18h',
    copyright: '© 2024 APL Consultoria e Assessoria Técnica Ltda. Todos os direitos reservados.',
    poweredBy: 'Powered by Readdy'
  }
};
